module.exports = __webpack_public_path__ + "static/media/home1.e2efd4fa.png";